<template>
  <div class="home">
<!--    <div style="height: 500px;width: 100%; position:relative;background: url('../../assets/home/002.png') 0 0/100% 100% no-repeat;width: 100%;">-->
<!--      <div style="position: absolute;z-index: 10;width: 100%;height: 100px;bottom: 40px;display: flex;justify-content: center;">-->
<!--        <div class="pointer" style="width: 200px;" @click="$login"></div>-->
<!--        <div class="pointer" style="width: 200px;" @click="goTo('/appoint')"></div>-->
<!--      </div>-->
<!--      <img src="@/assets/home/003.png" />-->

<!--    </div>-->
    <img src="../../assets/home/002.png" style="width: 100%" />
    <div style="position: absolute;width: 100%;z-index: 1;top: 160px">
      <div style="width: 1200px;margin: 0 auto;">
        <img src="../../assets/home/003.png" style="width: 300px;margin-left: 150px;margin-top: 40px" />
        <br />
        <br />
        <img src="../../assets/home/btn-1.png" @click="$login" style="margin-left: 150px;height: 50px;cursor: pointer" />
        <img src="../../assets/home/btn-2.png" @click="goTo('/appoint')" style="margin-left: 20px;height: 50px;cursor: pointer"  />
      </div>
    </div>

    <div class="home-title">
      <span>专业灵活的软件功能，让您的业务更顺畅</span>
    </div>
    <part-list :home="true" :part-list="list[0]" />
    <part-list :home="true" :part-list="list[1]" />
    <div style="height: 70px;"></div>
    <div style="background: #f1f8ff;height: 500px;">
      <div style="display: flex;justify-content: space-between; align-items: center;height: inherit;width: 1200px;margin: 0 auto;">
        <img src="@/assets/home/img1.png" style="width: 550px;">
        <div style="width: 560px;">
          <img src="@/assets/home/icon1.png" style="width: 80px;margin-bottom: 20px;">
          <div style="font-size: 26px;margin-bottom: 20px;">
            让财务管理简便易行，提升经营绩效立竿见影
          </div>
          <div style="font-size: 13px;color: #999;">
            包含企业财务管理的所有功能。你可以任何时间，任何地点访问最新业务数据，并且和你的专业会计师、虚拟CFO在云端协同，共享一套财务账。
          </div>
        </div>
      </div>
    </div>
    <div style="background: white;height: 570px;">
      <div style="display: flex;justify-content: space-between; align-items: center;height: inherit;width: 1200px;margin: 0 auto;">
        <div style="width: 520px;">
          <img src="@/assets/home/icon2.png" style="width: 80px;margin-bottom: 20px;">
          <div style="font-size: 26px;margin-bottom: 20px;">
            <span style="color: #20a0ff;">易用性</span>是筝鸣云财务软件的最大特点
          </div>
          <div style="font-size: 13px;color: #999;">
            筝鸣财务软件由澳大利亚设计师设计。数据录入迅速完成，现金流实现有效控制。你会轻松获取各种管理报表，进行科学财务和业务决策。          </div>
        </div>
        <img src="@/assets/home/img2.png" style="width: 550px;">
      </div>
    </div>
    <div style="background: #f1f8ff;height: 500px;">
      <div style="display: flex;align-items: center;height: inherit;width: 1200px;margin: 0 auto;justify-content: space-between;">
        <img src="@/assets/home/img3.png" style="width: 500px;">
        <div style="width: 570px;">
          <img src="@/assets/home/icon3.png" style="width: 80px;margin-bottom: 20px;">
          <div style="font-size: 26px;margin-bottom: 20px;">
            业务驱动财务
          </div>
          <div style="font-size: 13px;color: #999;">
            销售与采购账单处理，银行与业务交易对账，应收款跟踪，费用报销审核等业务与数据处理轻松完成。您的会计师可以轻松生成财务报表，并给出专业意见。          </div>
        </div>
      </div>
    </div>
<!--    <div class="home-title">-->
<!--      <span>听听客户怎么说</span>-->
<!--    </div>-->
<!--    <div class="comment">-->
<!--      <div v-for="i in 4" :key="i" class="user-comment">-->
<!--        <div class="user-comment__head">-->
<!--          <div class="user-comment__head__msg">-->
<!--            <img src="@/assets/home/msg.png"/>-->
<!--          </div>-->
<!--          <div class="user-comment__head__title">-->
<!--            在线财务软件的易用性?<br />-->
<!--            <span>王睿</span>-->
<!--            <span style="padding-right: 20px;">注册会计师</span>-->
<!--            <span style="color: #999;">3小时前</span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="user-comment__desc">-->
<!--          无论面授课还是在线课，我们都是同一套教材编写、教师培训体系，保证线上线下一致化。无论面授课还是在线课，我们都是同一套教材编写、教师培训体系，保证线上线下一致化。无论面授课还是在线课，我们都是同一套教材编写、教师培训体系，保证线上线下一致化。-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>
<script>
import PartList from '@/components/PartList'

export default {
  name: 'Home',
  components: { PartList },
  data() {
    return {
      list: [
        [
          {
            title: '管理仪表盘',
            desc: '通过仪表盘监控企业资金流、应收、应付、费用状况',
            img: require('@/assets/common/guanli.png'),
            path: '/dashboard'
          },
          {
            title: '银行与业务对账',
            desc: '快速完成银行对账单与业务交易的逐笔核销和对账',
            img: require('@/assets/common/yinhang.png'),
            path: '/reconciliation'
          },
          {
            title: '报表',
            desc: '标准化报表加EXCEL自定义报表工具，满足您多元的报表需求',
            img: require('@/assets/common/baobiao.png'),
            path: '/report'
          },
          {
            title: '发票管理',
            desc: '跟踪每笔业务的发票开具或收到状态、认证和抵扣状态',
            img: require('@/assets/common/fapiao.png'),
            path: '/bill'
          },
          {
            title: '多币别核算',
            desc: '多种币别记录交易数据，跟踪汇兑收益与损失',
            img: require('@/assets/common/duobibie.png'),
            path: '/currency'
          }
        ],
        [
          {
            img: require('@/assets/common/guding.png'),
            title: '财务检测助手',
            desc: '自动巡检账套，检测常见财务锗误与税务风险',
            path: '/financial'
          },
          {
            img: require('@/assets/common/xiaoshou.png'),
            title: '销售账单管控',
            desc: '跟踪销售账单收款状态，牢牢掌控应收账款',
            path: '/sale'
          },
          {
            img: require('@/assets/common/caigou.png'),
            title: '采购账单管控',
            desc: '跟踪采购账单付款状态，实现应付账款管理',
            path: '/purchase'
          },
          {
            img: require('@/assets/common/feiyong.png'),
            title: '费用报销管理',
            desc: '员工随时随地登录系统，完成费用报销申请与审批',
            path: '/reimbursement'
          },
          {
            img: require('@/assets/common/guding1.png'),
            title: '固定资产',
            desc: '集中管理，轻松维护您的固定资产',
            path: '/estate'
          }
        ]
      ]
    }
  },
  methods: {
    goTo(path) {
      this.$router.push({
        path: path
      })
    }
  }
}
</script>

<style scoped lang="scss">
.home{
  width: 100%;
  .home-title{
    text-align: center;
    font-size: 25px;
    padding: 60px;
    letter-spacing: 1px;
    font-weight: bold;
  }
  .home-serve-box{
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
    /*flex-wrap: wrap;*/
    display: flex;
    .home-serve{
      height: 315px;
      width: 200px;
      text-align: center;
      .home-serve__item{
        padding: 30px;
        &:hover{
          box-shadow: 0 0 20px rgba(66,155,245,0.3);
        }
        .home-serve__title{
          font-weight: bold;
          margin-top: 25px;
          margin-bottom: 17px;
        }
        .home-serve__desc{
          color: #999999;
          font-size: 12px;
        }
        img{
          width: 120px;
        }
      }
    }
  }
  .comment{
    width: 1200px;
    padding-bottom: 40px;
    margin: 0 auto;
    .user-comment{
      border: 1px solid #e2e2e2;
      margin-bottom: 25px;
      padding: 15px;
      &:hover{
        border: 1px solid #63acf9;
        box-shadow: 0 0 20px rgba(99,172,249, 0.3);
      }
      .user-comment__head{
        display: flex;
        font-size: 14px;
        margin-bottom: 15px;
        img{
          padding-top: 5px;
          width: 28px;
        }
        .user-comment__head__title{
          padding-left: 18px;
          font-size: 18px;
          span{
            color: #63acf9;
            padding-right: 16px;
            font-size: 13px;
          }
        }
      }
      .user-comment__desc{
        font-size: 14px;
        color: #999;
      }
    }
  }

}
</style>
